import { emptyNoteText } from '../constants';
export const filterEmptyNotes = notes => // when clicking on dropdown, a note is created, if the user does
// not do anything and leaves, a note with empty text has been created.
// upon unmounting of dashboard delete the note?
// if the note.note is null, it is crashing the ui.
notes.length ? notes.filter(note => note.note !== null && note.note !== undefined && note.note !== '' && note.note !== emptyNoteText) : notes;